import axiosInstance from '../axiosInstance'
import type { AxiosResponse } from 'axios'
import type { ISiteInfo } from '@/models/SiteInfo'

export type { ISiteInfo, SiteInfo } from '@/models/SiteInfo'

export const SiteInfoAPI = {
  async getSiteInfo(
    siteCode: string | null = null
  ): Promise<AxiosResponse<ISiteInfo[]>> {
    try {
      const url = `/api/siteInfo/${siteCode ?? ''}`
      const response = await axiosInstance.get<ISiteInfo[]>(url)
      console.log('Response:', response.data)
      return response
    } catch (error) {
      console.error('Error:', error)
      throw error
    }
  }
}
